import axios, { AxiosError } from "axios";
import customEvents from "../common/customEvents";

// export const BASE_URL = "https://tuktok-server.onrender.com";
export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3000"
    : "https://tuktok-server.onrender.com";

export const apiRoutes = {
  login: "/login",
  topics: "/topic/all",
  getPosts: () => "/post/all",
	getSubscribePosts: () => '/post/all?type=subscribe',
  getPostsByTopics: "/post/byTopics",
  getUserPosts: (username: string) => `/post/user/${username}`,
  getFavoritePosts: (username: string) =>
    `/post/user/${username}?type=favorite`,
  postPost: "/post/upload",
  likePost: (postId: string) => `/post/${postId}/like`,
  getVideo: (videoId: string) => `/video/${videoId}`,
  getVideoPreview: (videoId: string) => `/video/${videoId}/preview`,
  uploadAvatar: "/user/upload/avatar",
  getComments: (postId: string) => `/post/${postId}/comments`,
  postComment: (postId: string) => `/post/${postId}/comment`,
  deletePost: (postId: string) => `post/${postId}`,
  postLike: (type: "like" | "dislike", commentId: string) =>
    `/comment/${commentId}/${type}`,
  patchComment: (commentId: string) => `/comment/${commentId}`,
  patchUser: () => "/user",
  patchSubscribe: (userId: string) => `/user/${userId}/sub`,
  getUserDetails: (username: string) => `/user/${username}`,
  checkUsername: () => "/user/check/username",
};

export const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((config) => {
  const profile = localStorage.getItem("profile");
  if (config.headers && profile) {
    config.headers.set("token", JSON.parse(profile).token);
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status == 401) {
      if (localStorage.getItem("profile")) {
        localStorage.clear();
        window.location.replace("/");
      }
      window.dispatchEvent(new Event(customEvents.openLoginField));
    }
    return Promise.reject(error);
  }
);
